module.exports = __webpack_public_path__ + "static/media/shampoo1.5bf2c9dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bonus/shampoo1.jpg
// module id = 68
// module chunks = 0